function classNames(...args) {
  return args.filter((arg) => typeof arg === "string" || typeof arg === "number").join(" ");
}

export { classNames };
//# sourceMappingURL=class-names.js.map
